import { Callback, Step } from 'react-joyride'
import { Reducer } from 'redux'
import { ActionTypes, TOUR_ACTIONS } from './types'

export type State = {
  callback?: Callback
  isTourRunning: boolean
  steps: Step[]
}

const initialState: State = {
  callback: undefined,
  isTourRunning: false,
  steps: [],
}

export const tour: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case TOUR_ACTIONS.SET_CALLBACK: {
      return {
        ...state,
        callback: action.callback,
      }
    }

    // handle biz store
    case TOUR_ACTIONS.SET_IS_TOUR_RUNNING: {
      return {
        ...state,
        isTourRunning: action.isTourRunning,
      }
    }

    case TOUR_ACTIONS.SET_STEPS: {
      return {
        ...state,
        steps: action.steps,
      }
    }

    default:
      return state
  }
}
